import gql from 'graphql-tag';
export const roleRequirements = gql`
  fragment roleRequirements on RoleRequirement {
    questionId
    globalId
    question
    answerType
    rrAnswers {
      id
      globalId
      text
      isVerified
    }
    score
    status
    verifications {
      title
      credentialInfo {
        name
        values
      }
    }
  }
`;
